export default __webpack_public_path__ + "static/media/betwin365_receipt.2a2358f4.jpg";